import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import { Drawer } from "@material-ui/core";
import DisplaySettingsAccordion from "./DisplaySettingsAccordion";
import LinkListAccordion from "./LinkListAccordion";
import LanguageToggle from "./LanguageToggle";
import campusConfig from "../../../json/campus_config.json";

const MAIN_SCHOOL_COLOR = process.env.REACT_APP_MAIN_SCHOOL_COLOR;

const useStyles = makeStyles((theme) => ({
  list: { width: 280 },
  drawerHeader: {
    backgroundColor: MAIN_SCHOOL_COLOR,
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  headerLogo: {
    height: 32,
    width: "auto",
    maxWidth: "100%",
    objectFit: "contain",
  },
}));

const displaySettings = campusConfig.displaySettings || [];

/**
 * SVG内の表示要素を checkedState に基づいて表示/非表示にする。
 * 各 displaySetting の id をもとに、SVG内の #Id または #id 要素を探して
 * CSS クラス "hidden" で制御する。
 */
function applySvgVisibility(checkedState) {
  console.log("applySvgVisibility", checkedState);
  displaySettings.forEach((setting) => {
    const capitalized =
      setting.id.charAt(0).toUpperCase() + setting.id.slice(1);
    const el = document.querySelector(`#${capitalized}, #${setting.id}`);
    if (el) {
      checkedState[setting.id]
        ? el.classList.remove("hidden")
        : el.classList.add("hidden");
    }
  });
}

function MapDrawer({ open, onClose, displayChecked, onDisplayCheckedChange }) {
  const classes = useStyles();

  useEffect(() => {
    applySvgVisibility(displayChecked);
  }, [displayChecked]);

  return (
    <Drawer anchor="left" open={open} onClose={onClose}>
      <div className={classes.list}>
        <div className={classes.drawerHeader}>
          <img
            className={classes.headerLogo}
            src={`${process.env.PUBLIC_URL}/icons/menu_icon.png`}
            alt="University logo"
          />
          <LanguageToggle />
        </div>
        <DisplaySettingsAccordion
          displaySettings={displaySettings}
          checkedState={displayChecked}
          onCheckedChange={onDisplayCheckedChange}
        />
        <LinkListAccordion />
      </div>
    </Drawer>
  );
}

export default React.memo(MapDrawer);
